// Shared campaign <select> for the staff tool. Stateless presentation; the
// parent owns the campaign list + selection.
import React from 'react';
import { campaignTitle } from './api';

export default function CampaignPicker({
  id,
  label = 'Campaign',
  campaigns,
  value,
  onChange,
  disabled,
}) {
  const list = Array.isArray(campaigns) ? campaigns : [];
  return (
    <>
      <label className="staff-label" htmlFor={id}>
        {label}
      </label>
      <select
        id={id}
        className="staff-select"
        value={value || ''}
        disabled={disabled || list.length === 0}
        onChange={(e) => onChange(e.target.value)}
      >
        {list.length === 0 ? (
          <option value="">No active campaigns</option>
        ) : (
          <>
            <option value="">Select a campaign…</option>
            {list.map((c) => (
              <option key={c._id} value={c._id}>
                {campaignTitle(c)}
              </option>
            ))}
          </>
        )}
      </select>
    </>
  );
}
